import { Input } from '../../../../components/Inputs';
import { Dropdown, Form, Divider } from 'antd';
import { useHandleClickOutside } from '../../../../lib/hooks';
import Options from './Options';
import DragHandler from '../../../../components/Functionality/DragHandler';
import Collapser from '../../../../components/Collapser';
import TabToggle from "../../../../components/Inputs/TabToggle";
import { ModalAdditionSectionBottom, ModalAdditionSectionMore, ModalAdditionalSection, ModalOptions, ModalOptionsTitle } from '../../../../components/Layout/modal';

const Section = ({
  name,
  onRemove,
  draggableProps,
  dragHandleProps,
  innerRef,
  showingOptions,
  setShowing,
  unsetShowing,
  showingAllOptions,
  showingAnyOption,
}) => {
  const wrapperRef = useHandleClickOutside(unsetShowing, showingOptions);
  const sectionName = Form.useWatch(['sections', name, 'name']);
  const extraDropdownItems = [
    !showingOptions ? (
      {
        key: 'SHOW',
        label: 'Show options',
        onClick: () => { setShowing(); },
      }
    ) : (
      {
        key: 'UNSET_SHOW',
        label: 'Hide options',
        onClick: () => { unsetShowing(); },
      }
    )
  ];
  const dropdownItems = [{
    label: sectionName,
    key: '1',
    type: 'group',
    children: [
      ...(showingAllOptions ? [] : extraDropdownItems),
      {
        key: 'DELETE',
        label: 'Delete',
        onClick: () => { onRemove(); if (showingOptions) { unsetShowing(); } },
        danger: true,
      }
    ],
  }];
  return (
    <div {...draggableProps} ref={(n) => { innerRef(n); wrapperRef.current = n; }}>
      <ModalAdditionalSection>
        <ModalAdditionSectionBottom>
          <Input type="hidden" name={[name, 'id']} />
          <DragHandler disabled={showingOptions || showingAllOptions || showingAnyOption} {...dragHandleProps} disabledTooltip="Hide options to drag" />
        </ModalAdditionSectionBottom>
        <Input label={"Section " + (name + 1)} name={[name, 'name']} />
        <TabToggle
          options={[
            { label: 'Single', value: 'SINGLE' },
            { label: 'Multi select', value: 'MULTIPLE' }
          ]}
          label="Type"
          name={[name, 'type']}
        />
        {/*
          <TabToggle
            options={[
              { label: 'Optional', value: 'OPTIONAL' },
              { label: 'Required', value: 'REQUIRED' }
            ]}
            label="Required"
            name={[name, 'required_state']}
          />
        
        */}
        <Dropdown menu={{ items: dropdownItems }} trigger={['click']}>
          <ModalAdditionSectionBottom>
            <ModalAdditionSectionMore onClick={(e) => e.preventDefault()}>
              More
            </ModalAdditionSectionMore>
          </ModalAdditionSectionBottom>
        </Dropdown>
      </ModalAdditionalSection>
      <Collapser open={showingOptions || showingAllOptions}>
        <ModalOptions>
          <ModalOptionsTitle>Options</ModalOptionsTitle>
          <Form.List name={[name, 'options']}>
            {(fields, { add, remove, move }) => (
              <Options fields={fields} add={add} remove={remove} move={move} specialId={name} />
            )}
          </Form.List>
          <Divider />
        </ModalOptions>
      </Collapser>
    </div>
  );
};

export default Section;